import { defineComponent } from "@vue/composition-api";
import SummarySectionLayout from "./summary-section-layout.vue";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
export default defineComponent({
  name: "ApplicantsSection",
  components: {
    SummarySectionLayout
  },
  props: {
    hasMissingInformation: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const getApplicantEmail = applicant => {
      var _applicant$personalD;
      return (applicant == null ? void 0 : (_applicant$personalD = applicant["personal-details"]) == null ? void 0 : _applicant$personalD["email"]) || "";
    };
    const {
      IS_FILL_OUT
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.IS_FILL_OUT]);
    return {
      getApplicantEmail,
      IS_FILL_OUT
    };
  }
});